/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const PatientSummaryDisplayNamesFrag = `
    fragment PatientSummaryDisplayNamesFrag on PatientSummaryDisplayNames {
  fullName
  legalName
  expandedName
}
    `
export const PatientSummaryFrag = `
    fragment PatientSummaryFrag on PatientSummary {
  patientId
  userId
  treatmentId
  status
  programId
  email
  phoneNumber
  timeZone
  display {
    ...PatientSummaryDisplayNamesFrag
  }
  emrId
  lumaId
  nextgenId
}
    `
export const MinimalCareTeamSearchMemberFrag = `
    fragment MinimalCareTeamSearchMemberFrag on CareTeamSearchMember {
  careManagerId
  isPrimary
}
    `
export const MinimalSearchablePatientFrag = `
    fragment MinimalSearchablePatientFrag on SearchablePatient {
  id
  treatmentId
  emrId
  lumaId
  nextgenId
  mrn
  status
  name {
    fullName
  }
  address {
    state
  }
  timeZone
  videoRoomId
  dateOfBirth
  primaryPhone
  primaryEmail
  notices {
    label
    level
    code
    at
  }
  careTeam {
    careManagerId
    isPrimary
  }
  tracks {
    planId
    name
    templateId
    type
  }
}
    `
export const PatientNameFrag = `
    fragment PatientNameFrag on PatientName {
  firstName
  middleName
  lastName
  preferredName
  fullName
}
    `
export const AppointmentDisplayFrag = `
    fragment AppointmentDisplayFrag on AppointmentDisplay {
  startDateTime
  endDateTime
  type
  careManagerId
  careManagerDisplay
  serviceType
}
    `
export const PatientAddressFrag = `
    fragment PatientAddressFrag on PatientAddress {
  street
  city
  state
  zipcode
}
    `
export const SearchablePatientInsuranceFrag = `
    fragment SearchablePatientInsuranceFrag on PatientBillingInsurance {
  type
  insurancePlanId
  outOfNetwork
  outOfNetworkPlan {
    state {
      code
    }
    name
  }
  otherPayerInfo
}
    `
export const TrackFrag = `
    fragment TrackFrag on Track {
  planId
  name
  templateId
  type
}
    `
export const SearchablePatientFrag = `
    fragment SearchablePatientFrag on SearchablePatient {
  id
  treatmentId
  mrn
  emrId
  lumaId
  nextgenId
  medPlumPatientId
  mmrPatientId
  isIntegrationActive
  name {
    ...PatientNameFrag
  }
  status
  dischargeReason
  dateOfBirth
  primaryPhone
  primaryEmail
  signInPhone
  gender
  genderIdentity
  genderDetails
  preferredLanguage
  pronouns
  timeZone
  tags
  videoRoomId
  upcomingAppointments {
    ...AppointmentDisplayFrag
  }
  careTeam {
    careManagerId
    display
    isPrimary
  }
  address {
    ...PatientAddressFrag
  }
  notices {
    label
    level
    code
    at
  }
  selfPay
  billingInsurances {
    ...SearchablePatientInsuranceFrag
  }
  tracks {
    ...TrackFrag
  }
}
    `
export const SearchPatientsResponseFrag = `
    fragment SearchPatientsResponseFrag on SearchPatientsResponse {
  patients {
    ...SearchablePatientFrag
  }
  resultCount
  from
  searchAfter
  aggregations
}
    `
export const SearchPatientsDocument = `
    query searchPatients($query: AWSJSON!, $sort: AWSJSON, $aggregations: AWSJSON, $pageSize: Int, $from: Int) {
  searchPatients(
    query: $query
    sort: $sort
    aggregations: $aggregations
    pageSize: $pageSize
    from: $from
    searchAfter: null
  ) {
    ...SearchPatientsResponseFrag
  }
}
    ${SearchPatientsResponseFrag}
${SearchablePatientFrag}
${PatientNameFrag}
${AppointmentDisplayFrag}
${PatientAddressFrag}
${SearchablePatientInsuranceFrag}
${TrackFrag}`
export const GetAggregatesDocument = `
    query getAggregates($aggregations: AWSJSON!) {
  searchPatients(query: "{}", aggregations: $aggregations) {
    aggregations
  }
}
    `
export const PatientTypeAheadDocument = `
    query patientTypeAhead($query: AWSJSON!, $sort: AWSJSON, $pageSize: Int) {
  searchPatients(query: $query, sort: $sort, pageSize: $pageSize, from: 0) {
    resultCount
    patients {
      ...MinimalSearchablePatientFrag
    }
  }
}
    ${MinimalSearchablePatientFrag}`
export const SearchPatientByTreatmentIdDocument = `
    query searchPatientByTreatmentId($query: AWSJSON!) {
  searchPatients(query: $query, pageSize: 1, from: 0) {
    patients {
      ...MinimalSearchablePatientFrag
    }
  }
}
    ${MinimalSearchablePatientFrag}`
export const DescribePatientsByIdDocument = `
    query describePatientsById($patientIds: [String!]!, $forceInvalidate: Boolean) {
  describePatientsById(patientIds: $patientIds, forceInvalidate: $forceInvalidate) {
    ...PatientSummaryFrag
  }
}
    ${PatientSummaryFrag}
${PatientSummaryDisplayNamesFrag}`
export const DescribePatientsByUserIdDocument = `
    query describePatientsByUserId($userIds: [String!]!, $forceInvalidate: Boolean) {
  describePatientsByUserId(userIds: $userIds, forceInvalidate: $forceInvalidate) {
    ...PatientSummaryFrag
  }
}
    ${PatientSummaryFrag}
${PatientSummaryDisplayNamesFrag}`
export const DescribePatientsByTreatmentIdDocument = `
    query describePatientsByTreatmentId($treatmentIds: [String!]!, $forceInvalidate: Boolean) {
  describePatientsByTreatmentId(
    treatmentIds: $treatmentIds
    forceInvalidate: $forceInvalidate
  ) {
    ...PatientSummaryFrag
  }
}
    ${PatientSummaryFrag}
${PatientSummaryDisplayNamesFrag}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    searchPatients: build.query<
      Types.SearchPatients,
      Types.SearchPatientsVariables
    >({
      query: (variables) => ({ document: SearchPatientsDocument, variables }),
    }),
    getAggregates: build.query<
      Types.GetAggregates,
      Types.GetAggregatesVariables
    >({
      query: (variables) => ({ document: GetAggregatesDocument, variables }),
    }),
    patientTypeAhead: build.query<
      Types.PatientTypeAhead,
      Types.PatientTypeAheadVariables
    >({
      query: (variables) => ({ document: PatientTypeAheadDocument, variables }),
    }),
    searchPatientByTreatmentId: build.query<
      Types.SearchPatientByTreatmentId,
      Types.SearchPatientByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: SearchPatientByTreatmentIdDocument,
        variables,
      }),
    }),
    describePatientsById: build.query<
      Types.DescribePatientsById,
      Types.DescribePatientsByIdVariables
    >({
      query: (variables) => ({
        document: DescribePatientsByIdDocument,
        variables,
      }),
    }),
    describePatientsByUserId: build.query<
      Types.DescribePatientsByUserId,
      Types.DescribePatientsByUserIdVariables
    >({
      query: (variables) => ({
        document: DescribePatientsByUserIdDocument,
        variables,
      }),
    }),
    describePatientsByTreatmentId: build.query<
      Types.DescribePatientsByTreatmentId,
      Types.DescribePatientsByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: DescribePatientsByTreatmentIdDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
